/** Размеры кадра локального файла для сохранения в сообщении и слота превью. */
export async function readMessengerImageFileDimensions(
  file: File
): Promise<{ width: number; height: number } | null> {
  try {
    const bmp = await createImageBitmap(file);
    try {
      const w = bmp.width;
      const h = bmp.height;
      if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) return null;
      return { width: Math.trunc(w), height: Math.trunc(h) };
    } finally {
      bmp.close();
    }
  } catch {
    return readMessengerImageFileDimensionsViaImageUrl(file);
  }
}

async function readMessengerImageFileDimensionsViaImageUrl(
  file: File
): Promise<{ width: number; height: number } | null> {
  const url = URL.createObjectURL(file);
  try {
    const dims = await new Promise<{ width: number; height: number } | null>((resolve) => {
      const img = new Image();
      img.onload = () => {
        const w = img.naturalWidth;
        const h = img.naturalHeight;
        if (!w || !h) resolve(null);
        else resolve({ width: w, height: h });
      };
      img.onerror = () => resolve(null);
      img.src = url;
    });
    return dims;
  } finally {
    URL.revokeObjectURL(url);
  }
}
